import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthRequestSchedulePermission,
	GetHealthRequestSchedulePermissionModel,
	GetHealthRequestSchedulePermissionParams,
} from 'domain/usecases/private/booking-flow/health/get-health-request-schedule-permission';

export class RemoteGetHealthRequestSchedulePermission implements GetHealthRequestSchedulePermission {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthRequestSchedulePermissionModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthRequestSchedulePermissionParams): Promise<GetHealthRequestSchedulePermissionModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default: {
				throw new APIError(httpResponse.status, httpResponse.data);
			}
		}
	}
}
